module.exports = __webpack_public_path__ + "static/img/实验室安全检查.d0f84d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/实验室安全检查.png
// module id = yUIp
// module chunks = 13